<template>
	<div>
		<div class="alert alert-danger" v-if="show_error">
			<template v-for="error in errors">
				<p v-for="err in error" class="mb-0">{{	err  }}</p>
			</template>
		</div>
		<div class="content">
				<ul class="nav nav-tabs" id="myTab" role="tablist">
						<li class="nav-item" role="presentation" v-for="(item,index) in tabs_names" :key="index">
								<button class="nav-link" :class="{active:tabindex == item.id}" @click="trans_tabindex(item,index)">
										{{ item.name }}
								</button>
						</li>
				</ul>
				<div class="tab-content" id="myTabContent" style="position: relative;">
						<div class="tab-pane fade show active" :class="{active:tabindex == 0}">
							<div class="tabs-common">
								<tabs-header v-if="tabindex==0" @button="$payload => handleButtonVisibility($payload)" @change="get_page" :cur_tab_name="cur_tab_name" @input="$event=>inputDataFromTab($event)" :indata="in_document"></tabs-header>
								<tabs-names v-if="tabindex == 1" @button="$payload => handleButtonVisibility($payload)" @change="get_page" :cur_tab_name="cur_tab_name" @input="$event=>inputDataFromTab($event)" :indata="in_document"></tabs-names>
								<tabs-transport v-if="tabindex == 2" @button="$payload => handleButtonVisibility($payload)" @change="get_page" :cur_tab_name="cur_tab_name" @input="$event=>inputDataFromTab($event)" :indata="in_document"></tabs-transport>
								<tabs-financial v-if="tabindex == 3" @button="$payload => handleButtonVisibility($payload)" @change="get_page" :cur_tab_name="cur_tab_name" @input="$event=>inputDataFromTab($event)" :indata="in_document"></tabs-financial>
								<tabs-goods v-if="tabindex == 4" @button="$payload => handleButtonVisibility($payload)" @change="get_page" :cur_tab_name="cur_tab_name" @input="$event=>inputDataFromTab($event)" :indata="in_document"></tabs-goods>
								<tabs-attachment v-if="tabindex == 5" @button="$payload => handleButtonVisibility($payload)" @change="get_page" :document_id="document_id" :cur_tab_name="cur_tab_name" @input="$event=>inputDataFromTab($event)" :indata="in_document"></tabs-attachment>
								<tabs-endorsement v-if="tabindex == 6" @button="$payload => handleButtonVisibility($payload)" @change="get_page" :cur_tab_name="cur_tab_name" @input="$event=>inputDataFromTab($event)" :indata="in_document"></tabs-endorsement>
								<tabs-support v-if="tabindex == 7" @button="$payload => handleButtonVisibility($payload)" @change="get_page" :cur_tab_name="cur_tab_name" @input="$event=>inputDataFromTab($event)" :indata="in_document"></tabs-support>
						
								<div class="new-buttons d-flex" v-if="show_button">
									<div class="d-flex main-buttons">
										<button class="btn btn-outline-secondary" @click="clearForm">Clear</button>
										<button class="btn btn-success" @click="continueForm">Continue</button>
									</div>
									<validation
										:action="go_to_error"
										section="form_m"
										:contractId="$route.params.id"
										:item="form_m_id"
										buttonsSize=""
										:has_pre_action="true"
										:pre_action="preSaveDocument"
								/>
								</div>
							</div>
					</div>
						<div
      class="buttons d-none"
      style="position: absolute; bottom: 16px; right: 20%; left: 20px"
    >
      <div class="dropdown">
        <button
          v-if="show_button"
          class="btn btn-outline-success btn-sm dropdown-toggle"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          :disabled="buttons_loading"
        >
          {{
            $t(
              is_new
                ? "message.contracts.document_create"
                : "message.contracts.document_save",
            )
          }}&nbsp;&nbsp;
          <div
            class="loading loading-button"
            v-if="loading"
            style="
              border-top-width: 2px;
              border-top-color: #4caf50;
              top: 30px;
              right: -93px;
            "
          ></div>
        </button>
        <div
          class="dropdown-menu"
          name="create-invoice-dropdown-button"
          aria-labelledby="dropdownMenuButton"
        >
          <a
            name="create-invoice-add-button"
            class="dropdown-item"
            style="color: #4caf50"
            @click="saveDocument(false)"
            :disabled="buttons_loading"
            >{{
              $t(
                is_new
                  ? "message.contracts.document_create"
                  : "message.contracts.document_save",
              )
            }}</a
          >
          <a
            class="dropdown-item"
            style="color: #4caf50"
            @click="saveDocument(true)"
            :disabled="buttons_loading"
            >{{
              $t(
                is_new
                  ? "message.contracts.document_create_validate"
                  : "message.contracts.document_save_validate",
              )
            }}</a
          >
          <!-- <a class="dropdown-item" style="color: #4caf50;" v-if="!is_new"  @click="submit_and_sign_dialog()" :disabled=buttons_loading>{{$t('message.contracts.submit_and_sign_button')}}</a> -->
        </div>
      </div>
      <!--<button class="btn btn-success float-left" @click="saveDocument(false)" :disabled=buttons_loading>{{$t(is_new?'message.contracts.document_create':'message.contracts.document_save')}}</button>
			<button class="btn btn-success float-left" @click="saveDocument(true)" :disabled=buttons_loading>{{$t(is_new?'message.contracts.document_create_validate':'message.contracts.document_save_validate')}}</button> -->
      <!--<button v-if="!is_new" class="btn btn-success float-left" @click="submit_and_sign_dialog()" :disabled=buttons_loading>{{$t('message.contracts.submit_and_sign_button')}}</button> -->
      <!-- <button class="btn btn-info float-right" @click="exportEfreight()">e-Freight</button> -->
						<div style="position: absolute;right: 20px;top: 20px;z-index: 3;">
					<!-- <validation
							:action="go_to_error"
							section="form_m"
							:contractId="$route.params.id"
							:item="document_id"
							:buttons_visible="!is_new"
							:has_pre_action="true"
							:pre_action="preSaveDocument"
					/> -->
				</div>
    </div>
						<!-- <button class="btn btn-success mx-auto mt-3 mb-3 ml-auto mr-auto" v-if="show_button" @click.prevent="save">Save document</button> -->
				</div>
		</div>
	</div>
</template>
<script>
	import tabsHeader from './tabs-header'
	import tabsNames from './tabs-Names'
	import tabsTransport from './tabs-Transport'
	import tabsFinancial from './tabs-Financial'
	import tabsGoods from './tabs-Goods'
	import tabsAttachment from './tabs-Attachment.vue';
	import tabsEndorsement from './tabs-Endorsement'
	import tabsSupport from './tabs-Support'

	import validate from 'validate.js'

	import moment from 'moment'
	export default {
		name: "DocumentFormM",
		components: {
			tabsHeader,
			tabsNames,
			tabsTransport,
			tabsFinancial,
			tabsGoods,
			tabsAttachment,
			tabsEndorsement,
			tabsSupport
		},
		props: {
			goods: {
				type: Array
			}, 
			document_parent: {
				type: String,
			},
			contract_details: {
				type: Object
			}, 
			document_id: {
				type: String
			}, 
			is_new: {
				type: Boolean
			}, 
			document: {
				type: Object
			}
		},
		mounted(){
			if(this.is_new){
				this.loadDetails()
			}else{
				this.loadDocument(this.document_id)
			}

			this.in_document.form_m_year = new Date().getFullYear()
			this.in_document.valid_until = moment().add(365, 'days').format('YYYY-MM-DD')
			
		},
		watch: {
			in_document: {
				deep: true,
				handler(){
					this.in_document.form_number = this.in_document.form_m_prefix + '' +this.in_document.ad_bank_code + '' + this.in_document.form_m_year + '' + this.getIncrementingSequence()
				}
			}
		},
		methods: {
			preSaveDocument(){
				console.log('presave called')
				return new Promise((resolve, reject)=>{
					this.saveDocument(false, true).then(response=>{
						console.log('presave saved')
						console.log(response.data)
						if(typeof response.data.doc_id !== 'undefined'){
							this.doc_id = response.data.doc_id
							axios.get(`${window.base}/document/GetForm_M?doc_id=${response.data.doc_id}`).then(response=>{
								this.form_m_id = response.data.form_m_id
								resolve(this.form_m_id)
							})
							
						}else{
							reject()
						}
					}).catch(()=>{
						reject()
					})
				})
			},
			clearForm(){
				this.in_document = {}
			},
			continueForm(){
				if(this.tabindex<7){
					this.tabindex++
				}else{
					this.saveDocument()
				}
			},
			/**
				* Validates values of the data to fit databse requirements and data-sizes
				* @param {Object} data 
				* @param {Object} rules 
				*/
			validateData(data, rules){
				return validate(data, rules)
			},
			/**
     * Navigates user to the field with error
     */
					go_to_error(error) {
        switch (error.ControlNo) {
									case 'CN1.Main.W.100':
											this.get_page('', 4)
											break;
									case 'CN1.Main.W.001':
											this.get_page('', 0)
											break;
									case 'CN1.Main.W.002':
											this.get_page('', 0)
											break;
									case 'CN1.Main.W.003':
											this.get_page('', 0)
											break;
									case 'CN1.Main.W.004':
										this.get_page('', 0)
										break;									
									case 'CN1.Main.W.005':
										this.get_page('', 0)
										break;
									case 'CN1.Main.W.006':
										this.get_page('', 0)
											break;
									case 'CN1.Main.W.007':
											this.get_page('', 0)
											break;
									case 'CN1.Main.W.008':
											this.get_page('', 7)
											break;
        }
    },
			/**
				* loads an incrementing sequence number from backend, is hardcoded at the moment.
				*/
				getIncrementingSequence(){
					return '000000001';
			},
			/**
				* Fix numeric types
				* @param {Object} object 
				*/
			fixTypes(object){
				let numbers = [
					'form_m_id',
					'form_m_year',
					'ad_bank_code',
					// 'tin',
					'rc_number',
					'design_bank',
					'transp_mode',
					'exch_rate',
					'total_fob_value',
					'total_freight_charges',
					'total_anc_charges',
					'insh_value',
					'total_cf_value',
					'total_foc',
					'attach_sno',
					'attch_doc_type',
				]
				let tmp = {...object}
				Object.keys(tmp).forEach(key=>{
					if(numbers.includes(key)){
						
						if(tmp[key]=='')
							tmp[key]=0
						console.log(key, tmp[key], typeof tmp[key])
						tmp[key] = parseFloat(tmp[key])
					}
					if(key=='valid_forex')
						tmp[key] = tmp[key]===true?1:0;
					if(key=='transp_mode')
						if(tmp[key]>9)
							tmp[key] = 9
				})

				return tmp
			},
			/**
				* Handles button visibility (can be hidden or shown)
				* @param {Boolean} payload 
				*/
			handleButtonVisibility(payload){
				this.show_button = payload
			},
			/**
				* Is triggered by forms in tabs. Writes data from the tab to the document.
				* @param {Object} payload 
				*/
			inputDataFromTab(payload){
				this.in_document = {...this.in_document, ...payload}
			},
			/**
				* Don't know what it does, it came from Gan
				* @param {*} val 
				*/
			trans_tabindex(val) {
				this.tabindex = val.id
				this.cur_tab_name = val.name
			},
			/**
				* Don't know what it does, it came from Gan
				* @param {*} val 
				*/
			get_page(val1, val2) {
				this.tabindex = val2
				this.cur_tab_name = val1
			},
			/**
				* Saves document to the database
				* @param {Boolean} should_validate
				*/
			saveDocument(should_validate, return_promise = false){
				let url =  `${window.base}/Document/UpdateForm_M?doc_id=${this.document_id}`
				if(this.is_new){
					url =  `${window.base}/Document/CreateForm_M?attis_contract_id=${this.contract_details.attis_contract_id}`
				}
				const data = this.fixTypes(this.in_document)
				const validation = this.validateData(data, {
					form_type: {
					type: 'string',
					length: { maximum: 20 }
				},
				form_m_number: {
					type: 'string',
					length: { maximum: 40 }
				},
				form_m_prefix: {
					type: 'string',
					length: { maximum: 20 }
				},
				form_m_year: {
					type: 'number',
					numericality: { lessThan: 9999, onlyInteger: true }
				},
				ad_bank_code: {
					type: 'number',
					numericality: {
						onlyInteger: true
					}
				},
				ad_bank_address: {
					type: 'string',
					length: { maximum: 100 },
				},
				ad_branch: {
					type: 'string',
					length: { maximum: 20 }
				},
				form_number: {
					type: 'string',
					length: { maximum: 30 }
				},
				// valid_until: {
				// 	type: 'date'
				// },
				// tin: {
				// 	type: 'number',
				// 	// length: { maximum: 100 }
				// },
				// rc_number: {
				// 	type: 'number',
				// 	numericality: {
				// 		onlyInteger: true
				// 	}
				// },
				state_code: {
					type: 'string',
					length: { maximum: 50 }
				},
				app_city: {
					type: 'string',
					length: { maximum: 20 }
				},
				app_name: {
					type: 'string',
					length: { maximum: 50 }
				},
				app_address: {
					type: 'string',
					length: { maximum: 300 }
				},
				app_fax: {
					type: 'string',
					length: { maximum: 20 }
				},
				app_phone: {
					type: 'string',
					length: { maximum: 80 },
				},
				app_email: {
					type: 'string',
					length: { maximum: 40 },
				},
				bnf_name: {
					type: 'string',
					length: { maximum: 50 }
				},
				bnf_address: {
					type: 'string',
					length: { maximum: 300 },
				},
				bnf_country: {
					type: 'string',
					length: { maximum: 2 },
					presence: {allowEmpty: false}
				},
				bnf_phone: {
					type: 'string',
					length: { maximum: 80 }
				},
				bnf_fax: {
					type: 'string',
					length: { maximum: 20 }
				},
				bns_email: {
					type: 'string',
					length: { maximum: 40 }
				},
				cust_office: {
					type: 'string',
					length: { maximum: 20 }
				},
				transp_mode: {
					type: 'number',
					numericality: { lessThan: 10, onlyInteger: true },
					presence: true
				},
				transp_country: {
					type: 'string',
					length: { maximum: 2 },
				},
				supply_country: {
					type: 'string',
					length: { maximum: 2 },
				},
				discharge_port: {
					type: 'string',
					length: { maximum: 20 },
				},
				insp_agent: {
					type: 'string',
					length: { maximum: 20 },
				},
				// shipment_date: {
				// 	type: 'date'
				// },
				source_funds: {
					type: 'string',
					length: { maximum: 20 },
				},
				curr_code: {
					type: 'string',
					length: { maximum: 3 },
				},
				exch_rate: {
					type: 'number'
				},
				total_fob_value: {
					type: 'number',
				},
				total_freight_charges: {
					type: 'number'
				},
				total_anc_charges: {
					type: 'number'
				},
				insh_value: {
					type: 'number'
				},
				total_cf_value: {
					type: 'number'
				},
				total_foc: {
					type: 'number'
				},
				proforma_number: {
					type: 'string',
					length: { maximum: 50 }
				},
				// proforma_date: {
				// 	type: 'date'
				// },
				// endorsm_date: {
				// 	type: 'date'
				// },
				app_repr_name: {
					type: 'string',
					length: {
						maximum: 100
					}
				},
				// adb_endors_date: {
				// 	type: 'date',
				// },
				adb_name: {
					type: 'string',
					length: { maximum: 100 }
				},
				form_m_user: {
					type: 'string',
					length: { maximum: 100 }
				},
				action_doc: {
					type: 'string',
					length: { maximum: 100 }
				},
				// prev_submiss_date: {
				// 	type: 'date'
				// },
				so_message: {
					type: 'string',
					length: { maximum: 200 }
				}
			})
			if(validation && Object.keys(validation).length > 0){
				this.show_error = true
				this.errors = Object.values(validation)
			}else{
				data.sgd_goods = data.sgd_goods.map(item=>{
					item.hs_code = item.hs_code.value
					return item
				})
				this.show_error = false
				this.errors = []
				if(return_promise){
					return axios.post(url, data)
				}
				axios.post(url, data).then(response=>{
					if(response.data.status=='ok'){
						new Noty({
								theme: "light",
								type: "success",
								text: this.$root.$t("message.message.formm-created"),
								timeout: 5000,
						}).show();
						if(should_validate){
							this.$root.$emit("save-and-validate", response.data.doc_id);
						}else{
							this.$router.push({
								name: 'contracts-single-documents-tab',
								params: {
									id: this.contract_details.attis_contract_id
								}
							})
						}
					}else{
						new Noty({
								theme: "light",
								type: "error",
								text: this.$root.$t("message.message.formm-not-created"),
								timeout: 5000,
						}).show();
					}
				}).catch(()=>{
					new Noty({
								theme: "light",
								type: "error",
								text: this.$root.$t("message.message.formm-not-created"),
								timeout: 5000,
						}).show();
				})
			}
			},
			/**
				* Loads document from database
				* @param {String} document_id 
				*/
			loadDocument(document_id){
				axios.get(`${window.base}/document/GetForm_M?doc_id=${this.document_id}`).then(response=>{
					this.in_document = response.data
					this.form_m_id = response.data.form_m_id
					this.$root.$emit('form-m-loaded', this.in_document)
				})
			},
			/**
				* Prepare document on first load
				*/
			loadDetails(){
				//loading_documents
				axios.get(`${window.base}/document/preLoadForm_M?contract_id=${this.document_parent}`).then(response=>{
					console.log(response.data)
					this.in_document.form_type = 'form_m'
					if(response.data.tin!==-10)
						this.in_document.tin = parseInt(response.data.tin)
					if(response.data.state_code!==-10)
						this.in_document.state_code = response.data.state_code
					if(response.data.app_city!==-10)
						this.in_document.app_city = response.data.app_city.replaceAll("'", "`")
					if(response.data.app_name!==-10)
						this.in_document.app_name = response.data.app_name.replaceAll("'", "`")
					if(response.data.app_address!==-10)
						this.in_document.app_address = response.data.app_address.replaceAll("'", "`")
					if(response.data.app_phone!==-10)
						this.in_document.app_phone = response.data.app_phone.replaceAll("'", "`")
					if(response.data.app_email!==-10)
						this.in_document.app_email = response.data.app_email.replaceAll("'", "`")
					if(response.data.discharge_port!==-10)
						this.in_document.discharge_port = response.data.discharge_port.replaceAll("'", "`")
					if(response.data.loading_port!==-10)
						this.in_document.loading_port = response.data.loading_port.replaceAll("'", "`")
					if(response.data.cust_office!==-10)
						this.in_document.cust_office = response.data.cust_office
					if(response.data.transp_mode!==-10)
						this.in_document.transp_mode = response.data.transp_mode
					// if(response.data.transp_country!==-10)
						// this.in_document.transp_country = response.data.transp_country
					if(Array.isArray(response.data.product) && response.data.product[0]){
						this.in_document.transp_country = response.data.product[0].OriginCountryCode
					}
					if(response.data.CurrencyRate!==-10){
						this.in_document.exch_rate = response.data.CurrencyRate
					}
					if(response.data.supply_country!==-10)
						this.in_document.supply_country = response.data.supply_country
					if(response.data.curr_code!==-10 && response.data.curr_code!=='-10')
						this.in_document.curr_code = response.data.curr_code.toString()
					if(response.data.payment_mode!==-10 && response.data.payment_mode!=='-10')
						this.in_document.payment_mode = response.data.payment_mode.toString()
					if(response.data.payment_date!==-10 && response.data.payment_date!=='-10'){
						let d = response.data.payment_date.split(' ')
						d = d[0].split('.')
						if(d.length==3)
							this.in_document.payment_date = d[2]+'-'+d[1]+'-'+d[0]
						else
							this.in_document.payment_date = ''
					}
					if(response.data.terms_delivery !==-10 && response.data.terms_delivery !=='-10')
						this.in_document.terms_of_delivery  = response.data.terms_delivery.toString().trim()

						if(response.data.DocumentNumber !==-10 && response.data.DocumentNumber !=='-10')
							this.in_document.proforma_number = response.data.DocumentNumber
						if(response.data.DocumentDate !==-10 && response.data.DocumentDate !=='-10')
							this.in_document.proforma_date = response.data.DocumentDate
						if(response.data.GCost !==-10 && response.data.GCost !=='-10')
							this.in_document.total_fob_value = response.data.GCost
						if(response.data.TransportCharges !==-10 && response.data.TransportCharges !=='-10')
							this.in_document.total_freight_charges = response.data.TransportCharges
						if(response.data.InsuranceCharges !==-10 && response.data.InsuranceCharges !=='-10')
							this.in_document.insh_value = response.data.InsuranceCharges

						if(response.data.bnf_name !==-10 && response.data.bnf_name !=='-10')
							this.in_document.bnf_name = response.data.bnf_name.replaceAll("'", "`")
						if(response.data.bnf_address !==-10 && response.data.bnf_address !=='-10')
							this.in_document.bnf_address = response.data.bnf_address.replaceAll("'", "`")
						if(response.data.bnf_country !==-10 && response.data.bnf_country !=='-10')
							this.in_document.bnf_country = response.data.bnf_country.replaceAll("'", "`")
						if(response.data.bnf_phone !==-10 && response.data.bnf_phone !=='-10')
							this.in_document.bnf_phone = response.data.bnf_phone.replaceAll("'", "`")
						if(response.data.bnf_email !==-10 && response.data.bnf_email !=='-10')
							this.in_document.bnf_email = response.data.bnf_email.replaceAll("'", "`")

					response.data.product.forEach((good, index) => {
						var tmp_good = {};
						tmp_good.item_no = good.good_no;
						tmp_good.good_name = good.GoodsDescription;
						tmp_good.hs_code = good.GoodsCode;
						tmp_good.state_of_good = 0;
						tmp_good.sectoral_purpose = '';
						tmp_good.packages_qty = 0;
						tmp_good.packages_code = 0;
						tmp_good.net_weight = good.NetWeightQuantity;
						tmp_good.measure_code = good.SupplementaryQualifierName;
						tmp_good.measure_qty = good.GoodsQuantity;
						tmp_good.unit_price = good.Price;
						tmp_good.fob_value = good.Price * good.GoodsQuantity;
						tmp_good.freight_charges = good.TransportCharges;
						tmp_good.free_of_charge = 0;
						tmp_good.user_id = 0;
						tmp_good.sgd_item_date = '';

						tmp_good.good_country = good.OriginCountryCode;

						this.in_document.sgd_goods.push(tmp_good);

						this.findTNVED(good.GoodsCode, index);
					});
					console.log(this.in_document.sgd_goods)
					if(this.in_document.sgd_goods.length==0){
						console.log('loading goods from contract')
						axios.get(`${window.base}/Contract/GetContract?attis_contract_id=${this.document_parent}`).then(response1=>{
							response1.data.product.forEach((good, index) => {
								var tmp_good = {};
								tmp_good.item_no = good.good_no;
								tmp_good.good_name = good.attis_cg_good_name;
								tmp_good.hs_code = good.attis_cg_TNVED;
								tmp_good.state_of_good = 0;
								tmp_good.sectoral_purpose = '';
								tmp_good.packages_qty = 0;
								tmp_good.packages_code = 0;
								tmp_good.net_weight = 0;
								tmp_good.measure_code = good.attis_cg_measures;
								tmp_good.measure_qty = parseFloat(good.attis_cg_quantity);
								tmp_good.unit_price = parseFloat(good.attis_cg_price);
								tmp_good.fob_value = parseFloat(good.attis_cg_price) * parseFloat(good.attis_cg_quantity);
								tmp_good.freight_charges = 0;
								tmp_good.free_of_charge = 0;
								tmp_good.user_id = 0;
								tmp_good.sgd_item_date = '';

								tmp_good.good_country = '';

								this.in_document.sgd_goods.push(tmp_good);

								this.findTNVED(good.attis_cg_good_name, index);
								this.findLibValueProduct('measure', good.attis_cg_measures, 'measure_code', index)
							});
						})
					}
					this.$root.$emit('form-m-loaded', this.in_document)
				})
			},
			/**
				* Finds a library value and sets in human-readable form
				* @param {*} lib 
				* @param {*} value 
				* @param {*} field 
				* @param {*} index 
				*/
			findLibValueProduct(lib, value, field, index) {
			if (typeof lib == "string") {
				axios
					.get(
						window.base +
						"/library?type=" +
						lib +
						"&query=&qty=1000" +
						"&lang=" +
						this.$i18n.locale,
					)
					.then((response) => {
						response.data.forEach((item) => {
							if (
								item.value.trim().toLowerCase() == value.trim().toLowerCase()
							) {
								this.$set(this.in_document.sgd_goods[index], field, item);
							}
						});
					});
			}
			},
			/**
				* loads tnved data from database
			 */
			findTNVED(code, index) {
			axios
				.get(
					window.base +
					"/library/tnved?code=" +
					code.trim() +
					"&lang=" +
					this.$i18n.locale,
				)
				.then((response) => {
					if (typeof response.data[0] !== "undefined")
						this.$set(
							this.in_document.sgd_goods[index],
							"hs_code",
							response.data[0],
						);
				});
		},
		},
		data(){
			return {
				form_m_id: '',

				show_error: false,
				errors: [],
				loading: false,
				buttons_loading: false,
				show_button: true,
				tabindex: 0,
				cur_tab_name: 'Header',
				tabs_names: [
						{
								name: 'Header',
								id: 0,
						}, {
								name: 'Names&Parties',
								id: 1,
						}, {
								name: 'Transport',
								id: 2,
						}, {
								name: 'Financial',
								id: 3,
						}, {
								name: 'Goods',
								id: 4,
						}, {
								name: 'Attachment',
								id: 5,
						}, {
								name: 'Endorsement',
								id: 6,
						}, {
								name: 'Support Information',
								id: 7,
						}
				],
				in_document: {
					form_m_id: '',
					valid_forex: '',
					form_m_guid: '',
					form_type: '',
					form_m_number: '',
					form_m_prefix: 'BA',
					form_m_year: new Date().getFullYear(),
					ad_bank_code: 63,
					ad_bank_address: 'Nigeria',
					ad_branch: '',
					form_number: '',
					valid_until: '',
					tin: '',
					rc_number: '',
					state_code: '',
					app_city: '',
					app_name: '',
					app_address: '',
					app_fax: '',
					app_phone: '',
					app_email: '',
					bnf_name: '',
					bnf_address: '',
					design_bank: '',
					payment_mode: '',
					payment_date:'',
					terms_of_delivery: '',
					transfer_mode: '',
					bnf_country: 'NG',
					bnf_phone: '',
					bnf_fax: '',
					bns_email: '',
					cust_office: '',
					transp_mode: '',
					transp_country: '',
					supply_country: '',
					discharge_port: '',
					insp_agent: '',
					shipment_date: '',
					source_funds: '',
					curr_code: '',
					exch_rate: '',
					total_fob_value: '',
					total_freight_charges: '',
					total_anc_charges: '',
					insh_value: '',
					total_cf_value: '',
					total_foc: '',
					proforma_number: '',
					proforma_date: '',
					attach_sno: '',
					attch_doc_type: '',
					attach_ref_num: '',
					Attach_doc_date: '',
					attach_link: '',
					endorsm_date: '',
					app_repr_name: '',
					adb_endors_date: '',
					adb_name: 'Diamond Group',
					form_m_user: '',
					action_doc: '',
					prev_submiss_date: '',
					so_message: '',
					sgd_goods: [],
					files: [],
				},
				sgd_good: {
					sgd_id: 0,
					sgd_good_guid: '', //40
					sgd_guid: '', //40
					item_no: 0,
					hs_code: '', //12
					good_name: '', //256
					state_of_good: 0,
					good_country: '', //2
					sectoral_purpose: '', //20
					packages_qty: 0,
					packages_code: 0,
					net_weight: 0,
					measure_code: '', //3
					measure_qty: 0,
					unit_price: 0,
					fob_value: 0,
					freight_charges: 0,
					free_of_charge: 0,
					user_id: 0,
					sgd_item_date: '',
				}
			}
		}
	}
</script>
<style>
.tabs-common {
    font-family: Roboto;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0;
    text-align: left;
    background-color: #fff;
    position: relative;
    border-radius: 20px;
    padding: 24px;
}
.active .tabs-common{
	border-top-left-radius: 0;
}
.tabs-common .tabs-common{
	padding: 0;
	border-radius: 0;
}
.tabs-common .foot_pagination {
    width: 100%;
    color: #8D8D8D;
    position: absolute;
    bottom: 20px;
    text-align: center;
}
.bolder_label {
    font-weight: 600;
}
.common-title {
    font-family: Roboto;
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0em;
				margin-bottom: 1rem;
				margin-top: 1.75rem;
    text-align: left;
    color: #488E53;
}
.nav-tabs{border-bottom: 0 !important;}
.nav-tabs .nav-link{
	outline: none !important;
}
.nav-tabs .nav-link.active{
	border: none;
	border-bottom: 2px solid #488E53 !important;
}
.tabs-common input.form-control,
.tabs-common select.form-control,
.tabs-common .el-input__inner{
	border-radius: 8px !important;
	background: rgba(238, 238, 238, 0.93) !important;
	border: none !important;
	height: 56px !important;
	width: 80% !important;
}
.tabs-common select.form-control{
	-webkit-appearance: none;
	-moz-appearance: none;
	text-indent: 1px;
	text-overflow: '';
}
.tabs-common .select-wrapper{
	position: relative;
}
.tabs-common .select-wrapper:after{
	content: "";
	background-image: url('data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.29289 9.29289C6.68342 8.90237 7.31658 8.90237 7.70711 9.29289L12 13.5858L16.2929 9.29289C16.6834 8.90237 17.3166 8.90237 17.7071 9.29289C18.0976 9.68342 18.0976 10.3166 17.7071 10.7071L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L6.29289 10.7071C5.90237 10.3166 5.90237 9.68342 6.29289 9.29289Z" fill="%238D8D8D" fill-opacity="0.933333"/></svg>');
	width: 24px;
	height: 24px;
	display: block;
	position: absolute;
	right: calc(20% + 16px);
	top: 16px;
}
.tabs-common .el-input__inner{
	width: 100% !important;
}
.tabs-common .select-wrap, 
.el-date-editor.el-input{
	width: 80% !important;
}
.tabs-common .select-wrap .el-select{
	width: 100% !important;
}
.tabs-common .form-label-group input.form-control{
	width: 100% !important;
}
.tabs-common input.form-control::placeholder,
.tabs-common textarea.text_area_css::placeholder,
.tabs-common select[data-chosen=""],
.tabs-common .el-input__inner::placeholder{
	color: #8D8D8DEE !important;
	font-size: 14px;
}
.block_1{
	padding-bottom: 60px !important;
}
.el-date-editor .el-input__prefix i{
	background-image: url('data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 3C8 2.44772 7.55228 2 7 2C6.44772 2 6 2.44772 6 3V4H5C3.34315 4 2 5.34315 2 7V11V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V11V7C22 5.34315 20.6569 4 19 4H18V3C18 2.44772 17.5523 2 17 2C16.4477 2 16 2.44772 16 3V4H8V3ZM16 6H8V7C8 7.55228 7.55228 8 7 8C6.44772 8 6 7.55228 6 7V6H5C4.44772 6 4 6.44772 4 7V9.99999L20 10V7C20 6.44772 19.5523 6 19 6H18V7C18 7.55228 17.5523 8 17 8C16.4477 8 16 7.55228 16 7V6ZM4 19V12L20 12V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19Z" fill="%238D8D8D" fill-opacity="0.933333"/></svg>');
	background-repeat: no-repeat;
	background-position: center;
}
.el-date-editor .el-input__prefix i:before{
	content: '';
}
.el-date-editor .el-input__prefix{
	left: unset;
	right: 17px;
}
.el-date-editor.el-input--prefix .el-input__inner{
	padding-left: 16px;
}
.el-select .el-input__suffix i.el-input__icon{
	background-image: url('data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.29289 9.29289C6.68342 8.90237 7.31658 8.90237 7.70711 9.29289L12 13.5858L16.2929 9.29289C16.6834 8.90237 17.3166 8.90237 17.7071 9.29289C18.0976 9.68342 18.0976 10.3166 17.7071 10.7071L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L6.29289 10.7071C5.90237 10.3166 5.90237 9.68342 6.29289 9.29289Z" fill="%238D8D8D" fill-opacity="0.933333"/></svg>');
	background-position: center;
	transform: rotateZ(0deg);
	background-repeat: no-repeat;
}
.el-select .el-input__suffix i.el-input__icon:after,
.el-select .el-input__suffix i.el-input__icon:before{
	content: "";
}
.el-input__suffix{
	right: 17px !important;
}
.el-select .el-input__inner, 
.el-date-editor .el-input__inner{
	font-size: 16px;
	color: #333;
}
.new-buttons{
	gap: 10px;
 margin-top: 40px;
	justify-content: space-between;
}
.new-buttons .btn{
	height: 40px;
	padding: 0 24px;
	display: flex;
	border-radius: 8px;
	align-items: center;
	font-family: 'Roboto';
}
.new-buttons .btn.btn-success{
	display: flex;
	/* width: 154px; */
	height: 40px;
	padding: 16px 24px;
	justify-content: center;
	align-items: center;
	gap: 8px;
	border-radius: 8px;
	background: rgba(72, 142, 83, 0.93);
	border-color: rgba(72, 142, 83, 0.93);
}
.new-buttons .btn-success:not(:disabled):not(.disabled):active, .new-buttons  .btn-success:not(:disabled):not(.disabled).active,
.new-buttons .btn.btn-success:focus{
	background: rgba(72, 142, 83, 0.93) !important;
	border-color: rgba(72, 142, 83, 0.93) !important;
}
.new-buttons .main-buttons{
	gap: 10px;
}
.tabs-common input + label,
.tabs-common select + label{
	font-size: 10px;
	margin-top: -.5em;
	position: absolute;
	margin-top: -3.25rem;
	position: absolute;
	margin-left: 1.5em;
	opacity: .4;
	transition: all 0.5s;
}
.tabs-common input:placeholder-shown + label,
.tabs-common select[data-chosen=""] + label{
	opacity: 0;
	font-size: 14px;
	margin-top: -2.5rem;
	margin-left: 1.125em;
	transition: all 0.5s;
	opacity: 0;
}
.tabs-common input,
.tabs-common select{
	padding-top: 1rem;
	transition: all .5s;
}
.tabs-common input:placeholder-shown,
.tabs-common select[data-chosen=""]{
	padding-top: .5rem;
}
.tabs-common .form-control:focus{
	box-shadow: none !important;
	border: 2px solid var(--neutral-50, rgba(141, 141, 141, 0.93)) !important;
}
.nav.nav-tabs{
	font-family: Roboto;
}
.container-fluid.hh-100{
	padding-left: 28px !important;
	padding-right: 28px !important;
}
.container-fluid.hh-100 .main-really-raised .container{
	margin: 0 !important;
	padding: 0;
	width: 100%;
	max-width: 100% !important;
}
.container-fluid.hh-100 .col-md-3{
	padding-right: 12px !important;
}
.container-fluid.hh-100 .col-md-9{
	padding-left: 12px !important;
}
</style>
